import { render, staticRenderFns } from "./TicketUebersicht.vue?vue&type=template&id=2474e204"
import script from "./TicketUebersicht.vue?vue&type=script&lang=js"
export * from "./TicketUebersicht.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InternTicketsTicket: require('/Users/stefan/Dropbox/Stefan/gitrepos/yes/nachhilfe-app/components/intern/tickets/ticket.vue').default,ModalsTicketErfassen: require('/Users/stefan/Dropbox/Stefan/gitrepos/yes/nachhilfe-app/components/modals/TicketErfassen.vue').default})
